import type { ComponentProps } from "react";
import DualListBox from "react-dual-listbox";
import { ChevronLeftIcon, ChevronRightIcon } from "@sx-icons";

type DualListBoxIcons = NonNullable<ComponentProps<typeof DualListBox>["icons"]>;

/**
 * The move buttons' glyphs, shared by every DualListBox in the app (the LCO generator's load
 * case/combination pickers and the member design panel's section picker) so the two read as the
 * same control. The "move all" buttons are hidden in CSS — a run has a cap on how many sections it
 * may span, and a load combination set is chosen deliberately — but their icons are given anyway so
 * nothing falls back to the library's Font Awesome glyphs if that ever changes.
 */
export const dualListBoxIcons: DualListBoxIcons = {
  moveToAvailable: (
    <span>
      <ChevronLeftIcon />
    </span>
  ),
  moveAllToAvailable: [
    <span key={0}>
      <ChevronLeftIcon />
    </span>,
    <span key={1}>
      <ChevronLeftIcon />
    </span>,
  ],
  moveToSelected: (
    <span>
      <ChevronRightIcon />
    </span>
  ),
  moveAllToSelected: [
    <span key={0}>
      <ChevronRightIcon />
    </span>,
    <span key={1}>
      <ChevronRightIcon />
    </span>,
  ],
};
